var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.aplica)?_c('div',{staticClass:"mt-4 mt-md-5"},[_c('h3',{staticClass:"text-dark font-weight-bold mb-3 mb-md-5"},[_vm._v(_vm._s(_vm.titulo))]),(_vm.descripcion)?_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.descripcion))]):_vm._e(),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }